import React ,{Component} from 'react';
import ReactDOM from "react-dom";
import { HashRouter as Router, Route ,Routes,Navigate } from 'react-router-dom';
import './App.css';
import Apiurl from './components/Apiurl'
import './components/styles/styles.css';
import Layouthead from "./components/Layouthead";
import AddCountry from "./components/AddCountry";
import Comparativeprofitandloss from "./components/Comparative-profitandloss";

import Saletaxreport from "./components/Saletaxreport";
import Documentpreference from "./components/Documentpreference";
import Layoutcontent from "./components/Layoutcontent";
import AddSalesestimates from "./components/AddSalesestimates";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Adminsalesestimate from "./components/Adminsalesestimate";
import AdminCustomer from "./components/AdminCustomer";
import Estimateviewmore from "./components/Estimateviewmore";
import Salecreditnoteviewmore from "./components/Salecreditnoteviewmore";
import Adminsalescreditnote from "./components/Adminsalescreditnote";
import AddSalescreditnotes from "./components/AddSalescreditnotes";
import AdminState from "./components/AdminState";
import AddSalesinvoice from "./components/AddSalesinvoice";
import Adminsalesinvoice from "./components/Adminsalesinvoice";
import Salesinvoiceviewmore from "./components/Salesinvoiceviewmore";
import Addcustomer from "./components/Addcustomer";
import AddVendors from "./components/AddVendors";
import AdminVendors from "./components/AdminVendors";
import Addproducts from "./components/Addproducts";
import Adminproducts from "./components/Adminproducts";
import AdminLedger from "./components/AdminLedger";
import Adduser from "./components/AddUser";
import AddCompany from "./components/AddCompany";
import AdminCompany from "./components/AdminCompany";
import Addjournals from "./components/Addjournal";
import Adminjournals from "./components/Adminjournal";
import Paymentexpenses from "./components/Paymentexpenses";
import Adminuser from "./components/AdminUser";
import Vendorviewmore from "./components/Vendorviewmore";
import Customerviewmore from "./components/Customerviewmore";
import Vendorcreditnoteviewmore from "./components/Vendorcreditnoteviewmore";
import Vendorbillviewmore from "./components/Vendorbillviewmore";
import Adminvendorcreditnote from "./components/Adminvendorcreditnote";
import Addvendorcreditnote from "./components/Addvendorcreditnote";
import Adminvendorbills from "./components/Adminvendorbill";
import Addvendorbill from "./components/Addvendorbill";
import Paymentincoming from "./components/Paymentincoming";
import Financialsettings from "./components/Financialsettings";
import Myprofile from "./components/Myprofile";

import Adminsalestax from "./components/Adminsalestax";
import Statementsettings from "./components/Statementsettings";
import Journalviewmore from "./components/Journalviewmore";
import Mailsettings from "./components/Mailsettings";
import Businesssetting from "./components/Businesssetting";
import Purchaseorderviewmore from "./components/Purchaseorderviewmore";
import Adminpurchaseorder from "./components/Adminpurchaseorder";
import Addpurchaseorder from "./components/Addpurchaseorder";
import Changepassword from "./components/Changepassword";
import Templateandlogosetting from "./components/Templateandlogosetting";

import Navigationanddatagrids from "./components/Navigationanddatagrids";
import Settings from "./components/Settings";
import Aboutyourbusiness from "./components/Aboutyourbusiness";
import Chartofaccount from "./components/Chartofaccount";

import Auditrail from "./components/Auditrail";
import Accountspayabledetailesreport from "./components/Accountspayabledetailesreport";
import Accountspayablereport from "./components/Accountspayablereport";
import Accountsrecievabledetailedreport from "./components/Accountsrecievabledetailedreport";
import Salesdashboard from "./components/Salesdashboard";

/* Reports */
import Trialbalancereport from "./components/Trialbalancereport";

import Essentialreports from "./components/Essentialreports";
import Inventorystockmovementreport from "./components/Inventorystockmovementreport";
import Profitanalysisreport from "./components/Profitanalysisreport";
import Profitlossreports from "./components/Profitlossreports";
import Purchasedaybookreport from "./components/Purchasedaybookreport";
import Balancereport from "./components/Balancereport";
import Salesdaybookreport from "./components/Salesdaybookreport";
import StockMovementDetailedReport from "./components/StockMovementDetailedReport";

import Vendor1099Report from "./components/Vendor1099Report";
import Compdashboard from "./components/Compdashboard";

import Vendorrefund from "./components/Vendorrefund";
import Vendordashboard from "./components/Vendordashboard";
import Accesspagemessage from "./components/Accesspagemessage";
import Accountsrecievablereport from "./components/Accountsrecievablereport";
import Customerimport from "./components/Customerimport";
import Journalimport from "./components/Journalimport";
import Productsimport from "./components/Productsimport";
import Salesrevenuedetailedreport from "./components/Salesrevenuedetailedreport";
import Salesrevenuereport from "./components/Salesrevenuereport";
import Stockimport from "./components/Stockimport";
import Addvendorpayment from "./components/Addvendorpayment";

import Customerreciept from "./components/Customerreciept";
import Customerrefund from "./components/Customerrefund";
import Useradd from "./components/Useradd";
import Estimateviewmoreshare from "./components/Estimateviewmoreshare";

import Salesinvoiceviewmoreshare from "./components/Salesinvoiceviewmoreshare";
class App extends Component {
	 constructor(props) {
    super(props);
   
     this.state = {name:''}
     }
	 handleCallback = (childData) => {
        // Update the name in the component's state
		let strpageval=childData.split('~');
        this.setState({ name: strpageval[0], backbtn: strpageval[1]})
	
    }
   
render() {
    return ( 
	
	<Router basename="/">

	<Routes>
	Auditrai
	 <Route element={<Layouthead name={this.state.name} back={this.state.backbtn} />}>
	  <Route path="/Estimateviewmore" element="Sales Estimate"/>
	   <Route path="/AddSalescreditnotes" element="Sales Credit Notes"/>
	     <Route path="/AddSalesestimates" element="Sales Estimate"/>
		   <Route path="/Salecreditnoteviewmore" element="Sales Credit Notes"/>
		    <Route path="/Documentpreference" element="Document Preferences"/>
			<Route path="/Auditrail" element="Audit Trail"/>
				<Route path="/Accountspayabledetailesreport" element="Account Payable Deatil Report"/>
				<Route path="/Accountsrecievabledetailedreport" element="Accounts Recievable Details Report"/>
  <Route path="/Estimateviewmoreshare" element="Sales Estimate"/>
			
			<Route path="/Salesdashboard" element="Sales Dashboard"/>
  <Route path="/Salesinvoiceviewmoreshare" element="Sales Invoice"/>
<Route path="/Adminsalescreditnote" element="Sales Credit Notes"/>
<Route path="/AdminState" element="State"/>
<Route path="/AdminCustomer" element="Customer"/>
<Route path="/Addcustomer" element="Customer"/>

<Route path="/Saletaxreport" element="Sales Tax Report"/>
<Route path="/Useradd" element="User"/>
<Route path="/Compdashboard" element="Dashboard"/>
<Route path="/Vendordashboard" element="Vendor Dashboard"/>

<Route path="/Comparativeprofitandloss" element="Profit and Loss Comparative"/>
	 <Route path="/Adminsalesestimate" element="Sales Estimate"/>
	 <Route path="/AddSalesinvoice" element="Sales Invoice"/>
	  <Route path="/Adminsalesinvoice" element="Sales Invoice"/>
	   <Route path="/Salesinvoiceviewmore" element="Sales Invoice"/>
	     <Route path="/AddVendors" element="Vendor"/>
		   <Route path="/AdminVendors" element="Vendor"/>
		     <Route path="/Addproducts" element="Vendor"/>
		   <Route path="/Adminproducts" element="Vendor"/>
		     <Route path="/AdminLedger" element="Chart of Accounts "/>
			  <Route path="/Addvendorbill" element="Vendor Bill"/>
			   <Route path="/Adminvendorbills" element="Vendor Bill"/>
			   <Route path="/Addvendorcreditnote" element="Vendor Bill"/>
			    <Route path="/Adminvendorcreditnote" element="Vendor Bill"/>
				<Route path="/Vendorbillviewmore" element="Vendor Bill"/>
				<Route path="/Vendorcreditnoteviewmore" element="Vendor Bill"/>
		   <Route path="/Customerviewmore" element="Vendor Bill"/>
		     <Route path="/Vendorviewmore" element="Vendor Bill"/>
			   <Route path="/Adminuser" element="User Managemnet"/>
			   <Route path="/Adduser" element="User Managemnet"/>
			   <Route path="/AddCompany" element="Company"/>
		   <Route path="/AdminCompany" element="Company"/>
		   <Route path="/Addjournals" element="Journals"/>
		  <Route path="/Adminjournals" element="Journals"/>
		   <Route path="/AddCountry" element="Country"/>
		   	   <Route path="/Paymentexpenses" element="Country"/>
			    <Route path="/Addpurchaseorder" element="Country"/>
				<Route path="/Adminpurchaseorder" element="Purchase Order"/>
				<Route path="/Purchaseorderviewmore" element="Purchase Order"/>
				<Route path="/Changepassword" element="Change Password"/>
		       <Route path="/Documentpreference" element="Document Preferences"/>
		     <Route path="/Journalviewmore" element="Joiurnals"/>
		   <Route path="/Mailsettings" element="Purchase Order"/>
		   <Route path="/Businesssetting" element="Business Settings"/>
		   <Route path="/Paymentincoming" element="Paymentincoming"/>
		    <Route path="/Financialsettings" element="Financial settings"/>
			 <Route path="/Templateandlogosetting" element="Financial settings"/>
			  <Route path="/Statementsettings" element="Statementsettings"/>
			   <Route path="/Myprofile" element="Myprofile"/>
			     <Route path="/Settings" element="Business Settings"/>
			
			 <Route path="/Addvendorpayment" element="Payment (Outgoing money)"/>
			  <Route path="/Vendorrefund" element="Payment (Incoming money)"/>
			  <Route path="/Accesspagemessage" element="Accesspagemessage"/>
				 <Route path="/Adminsalestax" element="Tax"/>
			<Route path="/Navigationanddatagrids" element="Tax"/>
						<Route path="/Customerrefund" element="Payment (Outgoing money)"/>
				<Route path="/Customerreciept" element="Payment (Incoming money)"/>
				<Route path="/Salesdaybookreport" element="Sales Day Book Report"/>
					<Route path="/Aboutyourbusiness" element="About your Business "/>
					<Route path="/Chartofaccount" element="Chart of Account"/>
				<Route path="/Accountspayablereport" element="Accouns Payable Report"/>
			
			/*reports */
			<Route path="/Balancereport" element="Balancesheet Report"/>

			<Route path="/Essentialreports" element="Essential Report"/>
			<Route path="/Inventorystockmovementreport" element="Inventorystockmovement Report"/>
			<Route path="/Profitanalysisreport" element="Profit Analysis Report"/>
			<Route path="/Profitlossreports" element="Profit Loss Report"/>
			<Route path="/Purchasedaybookreport" element="Purchase Day Book Report"/>
			<Route path="/Salesdaybookreport" element="Sales Book Day Report"/>
			<Route path="/StockMovementDetailedReport" element="Stock Movement Summary Report"/>
			<Route path="/Vendor1099Report" element="1099 Vendor Report"/>
			
			<Route path="/Accountsrecievablereport" element="Accountsrecievablereport Report"/>
			<Route path="/Customerimport" element="Customerimport Report"/>
			<Route path="/Journalimport" element="Journalimport Report"/>
			<Route path="/Productsimport" element="Productsimport Report"/>
			<Route path="/Salesrevenuedetailedreport" element="Salesrevenuedetailed Report"/>
			<Route path="/Salesrevenuereport" element="Salesrevenue Report"/>
			<Route path="/Stockimport" element="Stockimport Report"/>
<Route path="/Trialbalancereport" element="Trial Balance Report"/>

			
				
	     </Route>
		 </Routes>
	<Routes>
	<Route element={<Layoutcontent />}>
	<Route path="/Navigationanddatagrids" element={<Navigationanddatagrids parentdasCallback={this.handleCallback}/>}/>
			<Route path="/Adminsalestax" element={<Adminsalestax parentdasCallback={this.handleCallback}/>}/>
	
	<Route path="/Useradd" element={<Useradd parentdasCallback={this.handleCallback}/>}/>

		<Route path="/Myprofile" element={<Myprofile parentdasCallback={this.handleCallback}/>}/>
		<Route path="/Settings" element={<Settings parentdasCallback={this.handleCallback}/>}/>}/>
	<Route path="/Statementsettings" element={<Statementsettings parentdasCallback={this.handleCallback}/>}/>
	<Route path="/Templateandlogosetting" element={<Templateandlogosetting parentdasCallback={this.handleCallback}/>}/>
	<Route path="/Documentpreference" element={<Documentpreference parentdasCallback={this.handleCallback}/>}/>
<Route path="/Financialsettings" element={<Financialsettings parentdasCallback={this.handleCallback}/>}/>

<Route path="/Saletaxreport" element={<Saletaxreport parentdasCallback={this.handleCallback}/>}/>
<Route path="/Comparativeprofitandloss" element={<Comparativeprofitandloss parentdasCallback={this.handleCallback}/>}/>	 
	<Route path="/Changepassword" element={<Changepassword parentdasCallback={this.handleCallback}/>}/>
	  <Route path="/Journalviewmore" element={<Journalviewmore parentdasCallback={this.handleCallback}/>}/>
	  <Route path="/Mailsettings" element={<Mailsettings parentdasCallback={this.handleCallback}/>}/>
<Route path="/Businesssetting" element={<Businesssetting parentdasCallback={this.handleCallback}/>}/>
<Route path="/Purchaseorderviewmore" element={<Purchaseorderviewmore parentdasCallback={this.handleCallback}/>}/>
<Route path="/Adminpurchaseorder" element={<Adminpurchaseorder parentdasCallback={this.handleCallback}/>}/>
 <Route path="/Addpurchaseorder" element={<Addpurchaseorder parentdasCallback={this.handleCallback}/>}/>
 <Route path="/Paymentincoming" element={<Paymentincoming parentdasCallback={this.handleCallback}/>}/>
 <Route path="/Paymentexpenses" element={<Paymentexpenses parentdasCallback={this.handleCallback}/>}/>
	 <Route path="/AddCountry" element={<AddCountry parentdasCallback={this.handleCallback}/>}/>
<Route path="/Addjournals" element={<Addjournals parentdasCallback={this.handleCallback}/>}/>
	   <Route path="/Adminjournals" element={<Adminjournals parentdasCallback={this.handleCallback}/>}/>
	  <Route path="/Salesdashboard" element={<Salesdashboard parentdasCallback={this.handleCallback}/>}/>
	   <Route path="/Compdashboard" element={<Compdashboard parentdasCallback={this.handleCallback}/>}/>
	   <Route path="/Accesspagemessage" element={<Accesspagemessage parentdasCallback={this.handleCallback}/>}/>
	    <Route path="/Vendorrefund" element={<Vendorrefund parentdasCallback={this.handleCallback}/>}/>
		   <Route path="/Addvendorpayment" element={<Addvendorpayment parentdasCallback={this.handleCallback}/>}/>

			 <Route path="/Customerreciept" element={<Customerreciept parentdasCallback={this.handleCallback}/>}/>		
				 <Route path="/Customerrefund" element={<Customerrefund parentdasCallback={this.handleCallback}/>}/>
	 <Route path="/AddCompany" element={<AddCompany parentdasCallback={this.handleCallback}/>}/>
	   <Route path="/AdminCompany" element={<AdminCompany parentdasCallback={this.handleCallback}/>}/>
	   <Route path="/Estimateviewmore" element={<Estimateviewmore parentdasCallback={this.handleCallback}/>}/>
	   <Route path="/Salecreditnoteviewmore" element={<Salecreditnoteviewmore parentdasCallback={this.handleCallback}/>}/>
	     <Route path="/Estimateviewmoreshare" element={<Estimateviewmoreshare parentdasCallback={this.handleCallback}/>}/>
	    
		 <Route path="/Salesinvoiceviewmoreshare" element={<Salesinvoiceviewmoreshare parentdasCallback={this.handleCallback}/>}/>
		<Route path="/AdminState" element={<AdminState parentdasCallback={this.handleCallback}/>}/>
  <Route path="/AddSalescreditnotes" element={<AddSalescreditnotes parentdasCallback={this.handleCallback}/>}/>
<Route path="/Adminsalescreditnote" element={<Adminsalescreditnote parentdasCallback={this.handleCallback}/>}/>
	    <Route path="/AdminCustomer" element={<AdminCustomer parentdasCallback={this.handleCallback}/>}/>
		 <Route path="/Addcustomer" element={<Addcustomer/>}/>
	     <Route path="/AddSalesestimates" element={<AddSalesestimates parentdasCallback={this.handleCallback}/>}/>
	 <Route path="/AddSalesinvoice" element={<AddSalesinvoice parentdasCallback={this.handleCallback}/>}/>
	 
	 <Route path="/Adminsalesestimate" element={<Adminsalesestimate parentdasCallback={this.handleCallback}/> }/>
<Route path="/Adminsalesinvoice" element={<Adminsalesinvoice parentdasCallback={this.handleCallback}/>}/>	    
		<Route path="/Salesinvoiceviewmore" element={<Salesinvoiceviewmore parentdasCallback={this.handleCallback}/>}/>
		 <Route path="/Addvendorbill" element={<Addvendorbill parentdasCallback={this.handleCallback}/>}/>
		
		 <Route path="/AdminLedger" element={<AdminLedger parentdasCallback={this.handleCallback}/>}/>
		  <Route path="/AdminVendors" element={<AdminVendors parentdasCallback={this.handleCallback}/>}/>
		   <Route path="/Addvendorcreditnote" element={<Addvendorcreditnote parentdasCallback={this.handleCallback}/>}/>
	 <Route path="/Adminvendorcreditnote" element={<Adminvendorcreditnote parentdasCallback={this.handleCallback}/>}/>	
 <Route path="/Vendorbillviewmore" element={<Vendorbillviewmore parentdasCallback={this.handleCallback}/>}/>	 
	
 <Route path="/Vendorcreditnoteviewmore" element={<Vendorcreditnoteviewmore parentdasCallback={this.handleCallback}/>}/>
 <Route path="/Vendorviewmore" element={<Vendorviewmore parentdasCallback={this.handleCallback}/>}/>
 <Route path="/Adduser" element={<Adduser parentdasCallback={this.handleCallback}/>}/>
 <Route path="/Adminuser" element={<Adminuser parentdasCallback={this.handleCallback}/>}/>
		  <Route path="/Adminproducts" element={<Adminproducts parentdasCallback={this.handleCallback}/>}/>
		   <Route path="/Adminvendorbills" element={<Adminvendorbills parentdasCallback={this.handleCallback}/>}/>
		     <Route path="/Customerviewmore" element={<Customerviewmore parentdasCallback={this.handleCallback}/>}/>
		<Route path="/Aboutyourbusiness" element={<Aboutyourbusiness parentdasCallback={this.handleCallback}/>}/>}/> 
		<Route path="/Chartofaccount" element={<Chartofaccount parentdasCallback={this.handleCallback}/>}/>}/> 
		<Route path="/Auditrail" element={<Auditrail parentdasCallback={this.handleCallback}/>}/>}/> 
		<Route path="/Accountsrecievabledetailedreport" element={<Accountsrecievabledetailedreport parentdasCallback={this.handleCallback}/>}/>}/> 


	

<Route path="/Trialbalancereport" element={<Trialbalancereport parentdasCallback={this.handleCallback}/>}/>}/> 

<Route path="/Accountspayabledetailesreport" element={<Accountspayabledetailesreport parentdasCallback={this.handleCallback}/>}/>}/> 

<Route path="/Accountspayablereport" element={<Accountspayablereport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Vendordashboard" element={<Vendordashboard parentdasCallback={this.handleCallback}/>}/>}/> 


/*reports */
<Route path="/Essentialreports" element={<Essentialreports parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Inventorystockmovementreport" element={<Inventorystockmovementreport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Profitanalysisreport" element={<Profitanalysisreport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Profitlossreports" element={<Profitlossreports parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Purchasedaybookreport" element={<Purchasedaybookreport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Salesdaybookreport" element={<Salesdaybookreport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/StockMovementDetailedReport" element={<StockMovementDetailedReport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Vendor1099Report" element={<Vendor1099Report parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Balancereport" element={<Balancereport parentdasCallback={this.handleCallback}/>}/>}/> 




<Route path="/Accountsrecievablereport" element={<Accountsrecievablereport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Customerimport" element={<Customerimport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Journalimport" element={<Journalimport parentdasCallback={this.handleCallback}/>}/>}/> 

<Route path="/Productsimport" element={<Productsimport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Salesrevenuedetailedreport" element={<Salesrevenuedetailedreport parentdasCallback={this.handleCallback}/>}/>}/> 
<Route path="/Salesrevenuereport" element={<Salesrevenuereport parentdasCallback={this.handleCallback}/>}/>}/>
<Route path="/Stockimport" element={<Stockimport parentdasCallback={this.handleCallback}/>}/>}/>





		</Route>
		 <Route exact	path="/Apiurl"   component={Apiurl}/>
	   <Route exact path="/"  element={<Navigate to="/Login" />}  />
            
            <Route path="/Login" element={<Login/>}/>
            <Route path="/Logout" element={<Logout/>}/> 


			
	  </Routes>
	   
	  
	
	
	 
	
	  

	
	  </Router>
	
	
    );
  }
}


export default App;
